import qs from 'qs'
import { DeserializeFilters } from '../../../../hooks/table-pages/use-endpoint-query-parameters'
import FormValues from '../components/filters-form/types/form-values'

export const deserializeFilters: DeserializeFilters = filtersString => {
    const formValues = qs.parse(filtersString) as Partial<FormValues>
    const filters: Record<string, any> = {}

    if (formValues.setId) {
        const id = Number(formValues.setId)
        if (!Number.isNaN(id)) {
            filters.id = { $eq: id }
        }
    }

    if (formValues.formNum) {
        filters.forms = { num: { $contains: formValues.formNum } }
    }

    return filters
}
